import React, { useState, useMemo, useRef, useEffect, useCallback } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { MoveLeft } from "lucide-react";
import { NavLink } from "react-router"
import SearchForm from "./SearchForm";
import { format, parseISO, isValid, startOfDay } from "date-fns";
import FlightSearchForm from "./FlightSearchForm";
import useDocumentTitle from '../../hooks/useDocumentTitle'
// import PassportExtractor from "./PassportExtractor";
// import SeatSelection from "../../components/SeatSelection";

const LAST_FLIGHT_SEARCH_KEY = 'lastFlightSearch';
const RECENT_FLIGHT_SEARCHES_KEY = 'recentFlightSearches';
const MAX_RECENT_FLIGHT = 5;
export default function Flight() {
  useDocumentTitle('Flight Search');
  const [recentFlightSearches, setRecentFlightSearches] = useState([]);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(RECENT_FLIGHT_SEARCHES_KEY);
      if (stored) setRecentFlightSearches(JSON.parse(stored));
    } catch (e) {
      console.error('Failed to read recent flight searches', e);
    }
  }, []);
  const formatDate = (date) => {
    if (!date) return "-";

    const parsedDate = typeof date === "string" ? parseISO(date) : date;

    if (!isValid(parsedDate)) return "-";

    const today = startOfDay(new Date());
    const selectedDate = startOfDay(parsedDate);

    // If date is before today, use today's date
    if (selectedDate < today) {
      return format(today, "dd-MMM-yyyy");
    }

    return format(parsedDate, "dd-MMM-yyyy");
  };
  const handleSearch = async (payload) => {
    const queryString = new URLSearchParams(payload).toString();
    window.location.href = `/flight/search?${queryString}`;
  };
  return (
    <>
      <div className="bg-gray-100 text-gray-800 relative min-h-screen">

        {/* Main Content */}
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 space-y-6">

          <SearchForm />
          {/* <SeatSelection /> */}
          {/* <PassportExtractor /> */}
          <h2 className="text-lg font-semibold text-left">
            Recent Search
          </h2>
          <div className="grid grid-cols-3 gap-2 mb-2">
            {recentFlightSearches.length > 0 && recentFlightSearches.map((item, idx) => (
              <section
                key={idx}
                className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow p-2 max-w-md"
              >
                {/* Route */}
                <div className="flex items-center justify-between mb-4">
                  <div>
                    <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
                      Journey
                    </p>

                    <h3 className="text-lg font-bold text-gray-900">
                      {item.from?.replace(/\s*\([^)]*\)/g, "")}
                      <span className="mx-2 text-gray-400">→</span>
                      {item.to?.replace(/\s*\([^)]*\)/g, "")}

                      {item.JourneyType === "2" && (
                        <>
                          <span className="mx-2 text-gray-400">→</span>
                          {item.from?.replace(/\s*\([^)]*\)/g, "")}
                        </>
                      )}
                    </h3>
                  </div>

                  <span className="text-xs whitespace-nowrap font-semibold bg-gray-100 text-gray-600 px-2.5 py-1 rounded-full">
                    {item.JourneyType === "2" ? "Round Trip" : "One Way"}
                  </span>
                </div>

                {/* Date */}
                <div className="bg-yellow-50 border border-yellow-100 rounded-lg px-3 py-2 mb-2">
                  {/* <p className="text-xs font-medium text-gray-500 mb-1">
                    Travel Date
                  </p> */}

                  <div className="text-lg font-bold text-yellow-700">
                    Travel On &nbsp;
                    {formatDate(item.departureDate)}

                    {item.JourneyType === "2" && (
                      <>
                        <span className="mx-2 text-gray-400">–</span>
                        {formatDate(item.returnDate)}
                      </>
                    )}
                  </div>
                </div>

                {/* Passenger Details */}
                <div className="flex items-center justify-between gap-4 pt-3 border-t border-gray-100">
                  <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-gray-600">
                    <span>
                      <strong className="text-gray-800">{item?.ADULT}</strong> Adult
                    </span>

                    <span>
                      <strong className="text-gray-800">{item?.CHILD}</strong> Child
                    </span>

                    <span>
                      <strong className="text-gray-800">{item?.INFANT}</strong> Infant
                    </span>

                    {item?.cabinClass && (
                      <span className="font-medium text-gray-800">
                        {item?.cabinClass}
                      </span>
                    )}
                  </div>

                  {/* Search Button */}
                  <button
                    type="button"
                    onClick={() => handleSearch(item)}
                    className="shrink-0 inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-yellow-500 hover:bg-yellow-600 text-white font-semibold text-sm transition-colors shadow-sm"
                  >
                    Search
                  </button>
                </div>
              </section>
            ))}
          </div>

        </main>

      </div>
      {/* <SearchForm /> */}

    </>
  );
}
